export const COELEMENT_DATA_KEY_PREFIX = "C$";
export const KEY_EVENT_LISTENERS = "K$";
export const COMPONENT_NAME_KEY = "N$";
export const IS_KEY = "S$";
export const BEFORE_MOUNT_KEY = "B$";
